import React, { useEffect, useState } from "react";
import './EventDetailsHeader.scss';
import dayjs from "dayjs";
import RealtimeHoursOpen from "../OpenEvents/RealTimeHoursOpen";
import TimeAlert from "../OtsEventCard/TimeAlert";
import { Tooltip, withStyles } from "@material-ui/core";
import { getAirborneLabelMessage } from "../OtsEventCard/Common/AirborneLabelMessage";

const formatTime = (inputTime: string, isTime: boolean): string => {
    const convertedTime = dayjs.utc(inputTime).local();
    return isTime ? convertedTime.format("HH:mm") : convertedTime.format("MM/DD/YY");
};
const formatTimeLocal = (inputTime: string, isTime: boolean): string => {
    const convertedTime = dayjs(inputTime);
    return isTime ? convertedTime.format("HH:mm") : convertedTime.format("MM/DD/YY");
};
const formatStationTime = (inputTime: string): string => {
    const convertedTime = dayjs(inputTime);
    return  convertedTime.format("HH:mm"); 
};


interface Props {
    otsEventData: any; // replace 'any' with the actual type
    isHistoryEvent: boolean | undefined;
}

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: 'white !important',
        color: 'var(--Primary-text, #00274A) !important',
        fontFamily: 'var(--auro-font-family-default) !important',
        fontSize: '16px !important',
        lineHeight: 'normal !important',
        letterSpacing: '-0.32px !important',
        fontStyle: 'normal !important',
        background: '#fff !important',
        border: 'unset !important',
        height: '50px !important',
        padding: '15px 25px 10px 25px !important',
        borderRadius: '4px !important',
        boxShadow: '0px 0px 5px 0px rgba(0, 0, 0, 0.15) !important',
        marginTop: '-3px !important',

    }
  }))(Tooltip);

export default function EventDetailsHeader({ otsEventData, isHistoryEvent }: Props): JSX.Element {
    const [compName, setCompName] = useState<string>("EventDetailsHeader");
    const [IsDiversion, setIsDiversion] = useState<boolean>(false);
    const [airborneMessage, setAirborneMessage] = React.useState<string>("");
    const NOT_APPLICABLE = "NotApplicable";

    useEffect(() => {
       if (
        otsEventData?.IsAirborneAtCreate &&
        otsEventData?.EventTypeCategory === NOT_APPLICABLE
        ) {
        const {label, isDiversion} = getAirborneLabelMessage(otsEventData);
        setAirborneMessage(label);
        setIsDiversion(isDiversion);
        }
        else{
        setAirborneMessage("");
        setIsDiversion(false);
        }
    }, [otsEventData]);

    return (
        <div>
            <div className="event-details-container">
                <div className="event-details-header-container">
                    <div className={otsEventData?.IsEtopsCapable === 'true' ? 'header-top-section etops-indicator' : 'header-top-section'}>
                        <div>
                            <span className="event-details-aircraft">{otsEventData?.AircraftRegistration}</span>
                        </div>
                        <div>
                            <span className="event-details-station">{otsEventData?.Station}</span>
                        </div>
                        <div className={otsEventData?.IsEtopsCapable === 'true' ? 'event-details-flight-icon' : 'event-details-flight-hide'}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M20 14.65V12.65L11.4883 8.162L11.4883 3C11.4883 3 11.4883 -7.15256e-07 10 -7.15256e-07C8.51064 -7.15256e-07 8.51064 3 8.51064 3L8.51064 8.162L0 12.65L0 14.65L8.51064 12.162V15.749L6.38192 18V20L9.99894 18.399L13.617 20V18L11.4883 15.749V12.162L20 14.65Z" fill="#068A1E" />
                            </svg>
                        </div>
                        <div className="spo-spacing">
                            <span className={IsDiversion?"diversion-label":"eta-label"}>{airborneMessage}</span>
                        </div>
                    </div>
                    <div className="event-details-problem-stmt-container">
                        <div className="event-details-problem-stmt">
                            {otsEventData?.ProblemText}
                        </div>
                    </div>
                    <div className="event-details-action-block-spacing"></div>
                    <div className="event-details-action-container">
                        <div className="event-details-action-subcontainer">
                            {otsEventData?.ReturnToServiceTimeUTC && !isHistoryEvent ? (
                                <div className={`event-details-action-block`}>
                                    <div className={`event-details-header-label`}>
                                        {otsEventData.AdviseTimeUTC ? "ADV" : "ETR"}
                                    </div>
                                    <div className={`event-details-header-text`}>
                                        {otsEventData.AdviseTimeUTC ?
                                            <span>{formatTime(otsEventData.AdviseTimeUTC, true)} . {formatTime(otsEventData.AdviseTimeUTC, false)} ({otsEventData.ADVBump})</span>
                                            : <span>{formatTime(otsEventData.EstimatedReturnToServiceTimeUTC, true)} . {formatTime(otsEventData.EstimatedReturnToServiceTimeUTC, false)} ({otsEventData.ETRBump})</span>}
                                    </div>
                                </div>
                            ) : (
                            <TimeAlert ADVBump={otsEventData.ADVBump}
                                AdviseTimeUTC={otsEventData.AdviseTimeUTC}
                                EstimatedReturnToServiceTimeUTC={otsEventData.EstimatedReturnToServiceTimeUTC}
                                ETRBump={otsEventData.ETRBump} 
                                compName={compName}
                                />
                            )}
                            <div className="second-block-row">
                                <div className="event-details-action-second-block">
                                    <div className="event-details-header-label">
                                        ETD
                                    </div>
                                    <div className="event-details-header-text">
                                        {otsEventData?.SETD ? formatTimeLocal(otsEventData?.SETD, true) : "-"}
                                    </div>
                                </div>
                                <div className="event-details-action-second-block">
                                    <div className="event-details-header-label">
                                        Loc
                                    </div>
                                    <HtmlTooltip title={otsEventData?.Location} placement="bottom" className="customTooltip">
                                                     
                                    <div className="event-details-header-text loc-text">
                                        {otsEventData?.Location}
                                    </div>
                                    </HtmlTooltip>
                                </div>
                                {!isHistoryEvent && (
                                <div className="event-details-action-second-block">
                                    <div className="event-details-header-label">
                                        OTS start
                                    </div>
                                    <div className="event-details-header-text">
                                        {formatTime(
                                            otsEventData?.OutOfServiceDateTimeUTC,
                                            true
                                        )}
                                    </div>
                                </div>
                                )}{" "}
                                {otsEventData?.ReturnToServiceTimeUTC && !isHistoryEvent && (
                                    <div className="event-details-action-second-block">
                                        <div className="event-details-header-label">
                                            OTS close
                                        </div>
                                        <div className="event-details-header-text">
                                            {formatTime(
                                                otsEventData?.ReturnToServiceTimeUTC,
                                                true
                                            )}
                                        </div>
                                    </div>
                                )}{" "}
                                <div className="event-details-action-second-block">
                                    <div className="event-details-header-label">
                                        IN
                                    </div>
                                    <div className="event-details-header-text">
                                        {otsEventData?.LastFlightDate ? formatTime(otsEventData?.LastFlightDate, true) : "-"}
                                    </div>
                                </div>
                                <div className="event-details-action-second-block">
                                    <div className="event-details-header-label">
                                        Time open
                                    </div>
                                    <div className="event-details-header-text">
                                        {otsEventData?.OutOfServiceDateTimeUTC && (
                                            <RealtimeHoursOpen
                                                outOfServiceDateTimeUTC={otsEventData?.OutOfServiceDateTimeUTC}
                                                returnToServiceDateTimeUTC={otsEventData?.ReturnToServiceTimeUTC}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}